import React from "react";
import moment from 'moment';

export function useBuildingAge(data: { builtAt: string }) {
    const currentDate = moment();
    const builtDate = moment(data.builtAt);

    const diffYear = currentDate.year() - builtDate.year();
    const diffMonth = currentDate.month() - builtDate.month();
    const diffTotalMonths = (diffYear * 12) + diffMonth; // 月単位での差を計算

    let buildingAge = '';
    if (diffTotalMonths < 12) {
        // 月数を計算
        buildingAge += `築${diffTotalMonths}ヶ月`;
    } else {
        // 年数を計算
        const finalDiffYear = Math.floor(diffTotalMonths / 12);
        buildingAge += `築${finalDiffYear}年`;
    }

    return buildingAge;
}